export const REQUEST_LINK_CATEGORY = "REQUEST_LINK_CATEGORY";
export const SET_LINK_CATEGORY = "SET_LINK_CATEGORY";
export const UPDATE_LINK_CATEGORY_FOR_LINK_CREATE =
  "UPDATE_LINK_CATEGORY_FOR_LINK_CREATE";
export const UPDATE_LINK_CATEGORY_FOR_LINK_UPDATE =
  "UPDATE_LINK_CATEGORY_FOR_LINK_CREATE";
